import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Contact.css';

const ContactPage = () => {
  return (
    <>
      <div className="page-wrapper">

      <Navbar />
      <main className="contact-container">
        <div className="container contact-flex">
          {/* Left: Contact Info */}
          <div className="contact-info">
            <h1 className="section_header text-center">Contact Us</h1>

            <div className="box address-block">
              <h4><strong>Get in touch</strong></h4>
              <div><strong>SmartVizX</strong></div>
              <a href="mailto:info@smartvizx.com">info@smartvizx.com</a>

              <div className="mt-4">
                <h4><strong>India Address</strong></h4>
                <p>
                 Ofis Square, Tower A1, Unit No. 120 (1st Floor), Sector 3,<br />
                  Noida, Uttar Pradesh - 201301, India<br />
                </p>

                <h4><strong>Dubai Address</strong></h4>
                <p>
                  2nd Floor, Business Village Block A,<br />
                  Port Saeed, Deira, Dubai
                </p>

                {/* <h4><strong>Registered Address</strong></h4>
                <p>
                  1st Floor, Greater Kailash-I,<br />
                  New Delhi - 110048
                </p> */}

                <h4><strong>For Sales Queries</strong></h4>
               <p>
  Disha Singh<br />
  <strong>Tel:</strong>
  <a className="no-underline" href="tel:+919818904540">+91 8527417771</a><br />
  <strong>Email:</strong>
  <a className="no-underline" href="mailto:Disha@smartvizx.com">Disha@smartvizx.com</a>
</p>

              </div>
            </div>
          </div>

          {/* Right: Map */}
          <div className="map-container">
   <iframe
  className="gmaps-iframe"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3503.625846441709!2d77.31327607628167!3d28.580995975692847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce52fc5e576e5%3A0xc0a4ad0b66eee14f!2sOfis%20Square%20Tower!5e0!3m2!1sen!2sin!4v1763549177149!5m2!1sen!2sin"
  style={{ border: 0, width: "100%", height: "100%" }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>




          </div>
        </div>
      </main>
      <Footer />
      </div>
    </>
  );
};

export default ContactPage;
